<template>
  <div class="box15">
    <pageTitle title="常见问题" text />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "当前国内软件测试岗位是否即将饱和？",
          answer: [
            "我国企业对于软件测试在整个软件行业中的重要作用认识较晚，这就导致了人才培养严重不足，因此专业的软件测试人才供需之间存在巨大的缺口。目前成熟公司如华为，测试:开发为1:1；而微软内部，软件测试人员与软件开发人员的比例一般为1.5:1 到 2.5:1 左右（即一个开发人员背后，有至少两位测试人员在工作，以保证软件产品质量）。当下国内整体测试与开发的比例大概仅为1:8，所以测试不仅火爆，而且增量潜力巨大、发展前景光明。",
          ],
        },
        {
          title: "为什么软件测试对女生没有歧视？",
          answer: [
            "软件测试工程师对性别没有特殊要求，注重经验的积累。做软件测试的人需要有耐性、细心、责任心等特征，这与女生的性格十分吻合。而且沟通技巧也很重要，不仅要接触开发人员，还要和产品、运维等人员进行沟通，这方面女生更具有独特的优势。而且在软件测试行业，有很多女生都是技术大神，各种工具、代码的能力不输男生。说得直白点，女生想要学习软件测试，完全不用担心自己的能力问题，只要愿意花时间、花精力、努力、认真，下一个测试行业的大佬可能就是你了。所以，目前软件测试工程师的从业男女比例大致维持在1:1左右。",
          ],
        },
        {
          title: "0基础跨行可以学习吗？",
          answer: [
            "据博学谷内部统计，0基础跨行学习软件测试学科的学生约占70%。软件测试课程简单、易学、好上手的特点，使得软件测试相比开发岗位而言，入门更为容易。非计算机专业学习编程开发都没有大问题，学习入门更为容易的软件测试，那就更不用担心了。",
          ],
        },
        {
          title: "为什么软件测试课程着重学习自动化等高级技能？",
          answer: [
            "不懂代码逻辑、不懂代码原理，技能就会过于单一。如果测试人员技能停留在只会“点、点、点”的手工测试（纯功能测试）阶段，技术实力不够就接触不到核心项目，职场之路很快就将陷入瓶颈期，根本没有机会冲击高薪。",
          ],
        },
        {
          title: "学完软件测试课程，是什么水平？",
          answer: [
            "博学谷软件测试课程，针对当前测试领域紧缺技术性人才需求，着重培养学生在职业发展中更具核心竞争力的中高级测试工程师技能，能够打造出招聘市场所需的复合型测试人才！课程涵盖Web自动化测试， 移动端自动化测试，接口自动化及性能测试，每个方向均为当前市场紧缺型技术，以市场为引导， 传授干货。课程完成后，学生将满足企业用人需求，学完即可上岗。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/java/box11/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("软件测试-就业课","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box15 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box15/bg.png")
    no-repeat;
  background-size: cover;

  .box {
    margin-top: 48px;
    ::v-deep {
      .item-answer {
        display: inline-block;
      }
    }
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
